import axios from 'axios';
import process from 'process';
import { AccountType } from '../components/Accounts/accounts-reducer';
import { UserType } from '../components/Users/users-reducer';

//const baseUrl ='https://bugs-api.webquake.com/api'
// const baseUrl ='https://localhost:4256/api'

//const baseUrl =  sessionStorage.getItem('apiurl')
const baseUrl = process.env.REACT_APP_API_URL

const workItemsWhere = "%5BWork%20Item%20Type%5D%20%3D%20%27Bug%27%20"
const workItemsFields = "System.Id%2CSystem.Tags%2CSystem.Title%2CSystem.State%2CSystem.WorkItemType%2CSystem.IterationPath%2CSystem.CreatedDate%2CSystem.ChangedDate%2CMicrosoft.VSTS.Common.Priority"

export const authAPI = {
  getToken(username: string, password: string) {
    console.log('APIURL:',  `${baseUrl}/token` )
    return axios.post(`${baseUrl}/token`, {username, password},  { headers: {
      'Acept': 'application/json',
      'Content-Type': 'application/json'
    }})
  },
  user(token: String) {
    return axios.get(`${baseUrl}/User/GetMe`, {
      headers: {
        'Acept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  forgotPassword(email: string){
    return axios.get(`${baseUrl}/Email?email=${email}`, {
      headers: {
        'Acept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
  },
  resetPasswort(userId: number, password: string){
    return axios.post(`${baseUrl}/email`, {userId, password},  { headers: {
      'Acept': 'application/json',
      'Content-Type': 'application/json'
    }})
  },
  checkResetLink(data: string){
    return axios.get(`${baseUrl}/Email/CheckResetLink?data=${data}`,  { headers: {
      'Acept': 'application/json',
      'Content-Type': 'application/json'
    }})
  }
}

export const projectsAPINEW = {
  getProjects(token: string) {
    return axios.get(`${baseUrl}/Project`, {
      headers: {
        'Acept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  createNewTask(token: string, projectId: number, title: string, priority: number, systemInfo: string , attachments: Array<{attachmentUrl: string}>) {
    return axios.post(`${baseUrl}/WorkItem/project/${projectId}/newWorkItem`, {projectId, title, priority, systemInfo, attachments}, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  fetchWorkItems(token: string, projectId: number, sort: string='', sortMode: string ='', query: string = ''){
    return axios.get(`${baseUrl}/WorkItem/project/${projectId}?where=${workItemsWhere}&fields=${workItemsFields}&query=${query}&Sort=${sort}&SortMode=${sortMode}`, {
      headers: {
        'Acept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  fetchItemData(token: string, projectId: number, itemId: number){
    return axios.get(`${baseUrl}/WorkItem/project/${projectId}/${itemId}`, {
      headers: {
        'Acept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  getItemComments(token: string, projectId: number, itemId: number) {
    return axios.get(`${baseUrl}/Comment/project/${projectId}/workitem/${itemId}`, {
      headers: {
        'Acept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  addComment(token: string, projectId: number, itemId: number, text: string) {
    return axios.post(`${baseUrl}/Comment/project/${projectId}/workItem/${itemId}/newComment?projectId=${projectId}&itemId=${itemId}`, {commentText: text}, {
     headers: { 'Content-Type': 'application/json-patch+json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + token}
    })
  },
  createAttachment(token: string, projectId: number, areaPath: string, fileName: string, formdata: any) {
    return axios.post(`${baseUrl}/Attachment/project/${projectId}/newAttachment?projectId=${projectId}&areaPath=${areaPath}&fileName=${fileName}`, formdata, {
      headers: {
        'Content-Type': 'multipart/form-data',
        //'Accept': 'application/json;api-version=1.0;excludeUrls=true',
       // 'Accept': 'multipart/form-data',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  getAttachment(token: string, projectId: number, attachmentId: string, fileName: string) {
    return axios.get(`${baseUrl}/Attachment/project/${projectId}/${attachmentId}/${fileName}`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
     // responseType: 'stream'
      responseType: 'blob'
    })
  },
  addAttachment(token: string, projectId: number, itemId: number, url: string) {
    return axios.put(`${baseUrl}/Attachment/project/${projectId}/workitem/${itemId}?projectId=${projectId}&itemId=${itemId}`, {attachmentUrl: url}, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  removeAttachment(token: string, projectId: number, itemId: number, index: number) {
    return axios.delete(`${baseUrl}/Attachment/project/${projectId}/workitem/${itemId}?projectId=${projectId}&itemId=${itemId}&index=${index}`, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  updateTask(token: string, projectId: number, taskId: number, state: string, systemInfo: string){
    return axios.put(`${baseUrl}/WorkItem/project/${projectId}/${taskId}`, {projectId, taskId, state, systemInfo}, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  }
}

export const usersAPI = {
  getUsersByAccount(token: string, accountId: number){
    return axios.get(`${baseUrl}/User/GetAll/${accountId}`, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  createUser(token: string, user: UserType){
    return axios.post(`${baseUrl}/User`, user, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  updateUser(token: string, user: UserType){
    return axios.put(`${baseUrl}/User/${user.id}`, user, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  updateMe(token: string, user: UserType){
    return axios.put(`${baseUrl}/User/UpdateMe/${user.id}`, user, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  deleteUser(token: string, userId: number){
    return axios.delete(`${baseUrl}/User/${userId}`, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  }
}

export const accountsAPI = {
  getAccounts(token: string){
    return axios.get(`${baseUrl}/Account`, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  getAccount(token: string, id: number){
    return axios.get(`${baseUrl}/Account/${id}`, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  createAccount(token: string, account: AccountType) {
    return axios.post(`${baseUrl}/Account`, account, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  updateAccount(token: string, id: number,  name: string, email: string, description: string, isActive: boolean) {
    return axios.put(`${baseUrl}/Account/${id}`, {id, name, email, description, isActive }, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  deleteAccount(token: string, id: number){
    return axios.delete(`${baseUrl}/Account/${id}`, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  }
}

export const notificationAPI = {
  getAll(token: string, userId: number){
    return axios.get(`${baseUrl}/Notification?userId=${userId}`, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  },
  deleteNotification(token: string, itemId: number){
    return axios.delete(`${baseUrl}/Notification?taskId=${itemId}`, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
  }
}



export type ProjectType = {
  id: number
  projectGuid: string
  projectName: string
  projectDescription: string
  revision: number
  rowVersion: string
  state: string
  url: string
  visibility: string
  lastUpdateTime: string
  users: Array<any>
}
export type ResponseProjectType = {
  count: number
  value: Array<ProjectType>
}
export type FieldErrorType = { field: string, error: string }
export type ResponseType<Data = {}> = {
  resultCode: number
  messages: Array<string>
  fieldsErrors?: Array<FieldErrorType>
  data: Data
}
export type CommentType = {
  revisedDate: string
    revision: number
    text: string
    url: string
  revisedBy: {
    id: string
    displayName: string
    url: string
    Descriptor: string
    imageUrl: string
    uniqueName: string
    _links?: {
     }
  }

}
export type CommetsResponseType = {
  totalCount: number
  count: number
  comments: Array<CommentType>
}

type WorkItemFieldsType = {
  ['System.AreaPath']?: string
  ['System.IterationPath']: string
  ['System.Title']?: string
  ['System.State']?: TaskStateType
  ['System.Description']?: string
  ['System.WorkItemType']?: string
  ['Microsoft.VSTS.Common.Priority']?: number
  ['Microsoft.VSTS.TCM.ReproSteps']?: string
  ['Microsoft.VSTS.TCM.SystemInfo']?: string
  ['System.CommentCount']: number
  ['System.ChangedDate']: string
  ['System.ChangedBy']?: {
    descriptor: string
    displayName: string
    id: string
    imageUrl: string
    uniqueName: string
    url: string
    _links: {
      avatar: {
        href: string
      }
    }
  }
  ['System.CreatedDate']: string
  ['System.AssignedTo']?: {
    descriptor?: string
    displayName?: string
    id?: string
    imageUrl?: string
    uniqueName?: string
    url?: string
    _links: {
      avatar: {
        href: string
      }
    }
  }
}
export type RelationsType = {
  rel: string
  url: string
  attributes: {
    authorizedDate: string
    id: number
    name: string
    resourceCreatedDate: string
    resourceModifiedDate: string
    resourceSize: number
    revisedDate: string
  }
}
export type WorkItemType = {
  id: number
  url: string
  rev?: any
  fields: WorkItemFieldsType
  _links?: {
    workItemComments: {
      href: string
    }
  }
  relations: RelationsType[]
  commentsData: CommetsResponseType
  myCommentText: string
  isUpdated: boolean
}

export type TaskStateType = "New" | "Active" | "Resolved" | "Closed" | ""

export type UpdatedTasksResponse = {
  id: number
  userId: number
  workItemId: number
  isRead: boolean
  readDate: null | string
  created: string
  modified: string
  rowVersion: string
}

export type LoginParamsType = {
  email: string
  password: string
}